import React from 'react';

import { withTranslation } from 'providers/GILT.provider';

class TableSortHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDateAsc: true,
      isAudienceAsc: true,
      isReipientsAsc: true,
      isBookingReceivedAsc: true,
      isBookingValueAsc: true,
      isSmsSentAsc: true,
      isSmsCostAsc: true,
    };
  }

  render() {
    const { sortFunction, t } = this.props;

    return (
      <div data-bem="TableSortHeader" className="sticky-navbar">
        <table className="tbl-campaigns-sort">
          <tbody>
            <tr>
              <td className="date-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortFunction('dateSent', this.state.isDateAsc);
                    this.setState({ isDateAsc: !this.state.isDateAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableHeaders.dateSent')}
                </span>
              </td>
              <td className="target-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortFunction('targetAudience', this.state.isAudienceAsc);
                    this.setState({ isAudienceAsc: !this.state.isAudienceAsc });
                  }}
                  className="sort-btn no-arrow"
                >
                  {t('campaigns.tableHeaders.audience')}
                </span>
              </td>
              <td className="message-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortFunction('recipients', this.state.isReipientsAsc);
                    this.setState({ isReipientsAsc: !this.state.isReipientsAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableHeaders.recipients')}
                </span>
              </td>
              <td className="sms-sent-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortFunction('smsSent', this.state.isSmsSentAsc);
                    this.setState({ isSmsSentAsc: !this.state.isSmsSentAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableHeaders.sentTexts')}
                </span>
              </td>
              <td className="booking-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortFunction('bookingRecieved', this.state.isBookingReceivedAsc);
                    this.setState({ isBookingReceivedAsc: !this.state.isBookingReceivedAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableHeaders.bookings')}
                </span>
              </td>
              <td className="revenue-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortFunction('bookingValue', this.state.isBookingValueAsc);
                    this.setState({ isBookingValueAsc: !this.state.isBookingValueAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableHeaders.revenue')}
                </span>
              </td>
              <td className="sms-cost-width">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    sortFunction('smsCost', this.state.isSmsCostAsc);
                    this.setState({ isSmsCostAsc: !this.state.isSmsCostAsc });
                  }}
                  className="sort-btn"
                >
                  {t('campaigns.tableHeaders.textsCost')}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

const TableSortHeaderHoc = withTranslation()(TableSortHeader);
export default TableSortHeaderHoc;
